@if (page) {
  <app-header></app-header>
}
<div class="confirm-container" [class.fullLength]="page">
  <div class="header">
    <h4>Plan Usage Details</h4>
    @if (!page) {
      <button type="button" class="close" (click)="closeModal()">
        <img src="assets/icons/icon-close.svg" alt="Close" />
      </button>
    }
  </div>

  <div class="confirm-content">
    <table class="usage-table">
      <thead>
        <tr>
          <th>Feature</th>
          <th>Allowed</th>
          <th>Used</th>
        </tr>
      </thead>
      <tbody>

        <!-- Journals -->
        <tr>
          <td>Create Journals</td>
          <td>{{ subscription_features?.can_journal ? 'Yes' : 'No' }}</td>
          <td>{{ usage?.journals_created }}</td>
        </tr>

        <tr>
          <td>Delegate Journals</td>
          <td>{{ subscription_features?.delegate_journal ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Wiki -->
        <tr>
          <td>Access Wiki</td>
          <td>{{ subscription_features?.access_wiki ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <tr>
          <td>Wiki Ownership</td>
          <td>{{ subscription_features?.wiki_ownership ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <tr>
          <td>Delegate Wiki</td>
          <td>{{ subscription_features?.delegate_wiki ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Modules -->
        <tr>
          <td>Create Modules</td>
          <td>{{ subscription_features?.create_modules ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Favorite Content -->
        <tr>
          <td>Favorite Content</td>
          <td>{{ subscription_features?.favorite_content ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Characters -->
        <tr>
          <td>Active Characters</td>
          <td>{{ subscription_features?.max_active_characters === -1 ? 'Unlimited' :
          subscription_features?.max_active_characters }}</td>
          <td>{{ usage?.characters_created }}</td>
        </tr>

        <tr>
          <td>Retired NPCs</td>
          <td>{{ subscription_features?.max_retired_npcs === -1 ? 'Unlimited' :
          subscription_features?.max_retired_npcs }}</td>
          <td>{{ usage?.retired_npcs_created }}</td>
        </tr>

        <!-- Maps -->
        <tr>
          <td>Maps Uploaded</td>
          <td>{{ subscription_features?.maps_uploaded === -1 ? 'Unlimited' :
          subscription_features?.maps_uploaded }}</td>
          <td>{{ usage?.maps_uploaded }}</td>
        </tr>

        <tr>
          <td>Can Upload Maps</td>
          <td>{{ subscription_features?.upload_maps ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <tr>
          <td>Can Delete Maps</td>
          <td>{{ subscription_features?.delete_maps ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- WorldTumbler Map Access -->
        <tr>
          <td>Access WorldTumbler Map</td>
          <td>{{ subscription_features?.access_wt_map ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Games -->
        <tr>
          <td>Games Created</td>
          <td>{{ subscription_features?.max_games_created === -1 ? 'Unlimited' :
          subscription_features?.max_games_created }}</td>
          <td>{{ usage?.games_created }}</td>
        </tr>

        <tr>
          <td>Games Joined</td>
          <td>{{ subscription_features?.can_join_games ? 'Yes' : 'No' }}</td>
          <td>{{ usage?.games_joined }}</td>
        </tr>

        <tr>
          <td>Can Create Games</td>
          <td>{{ subscription_features?.create_games ? 'Yes' : 'No' }}</td>
          <td>-</td>
        </tr>

        <!-- Party Members -->
        <tr>
          <td>Party Members per Game</td>
          <td>{{ subscription_features?.party_members === -1 ? 'Unlimited' :
          subscription_features?.party_members }}</td>
          <td>{{ usage?.party_members_created }}</td>
        </tr>

        <!-- AI Token -->
        <tr>
          <td>AI Tokens Generated</td>
          <td>{{ subscription_features?.ai_token_generated === -1 ? 'Unlimited' :
          subscription_features?.ai_token_generated }}</td>
          <td>-</td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
@if (page) {
  <app-footer></app-footer>
}